import { JSX } from 'react';
import { KibButtonNew, KibButtonNewProps } from '@chewy/kib-controls-react';
import { LegalText } from '@src/components/legal';

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css';
import '@src/components/footer/index.scss';

interface CTABaseProps
  extends KibButtonNewProps<HTMLButtonElement | HTMLAnchorElement> {
  label: string;
  disabled?: boolean;
  'aria-describedby'?: string;
}
export type CTA = CTABaseProps &
  (
    | {
        onClick: () => void;
        type?: string;
        form?: never;
      }
    | {
        onClick?: never;
        type: 'submit';
        form: string;
      }
  );

export const Footer = ({
  primaryCTA,
  secondaryCTA,
  legalText,
  showFooterLegal = true,
}: {
  primaryCTA: CTA;
  secondaryCTA?: CTA;
  legalText?: 'PRIVACY' | 'AFFIDAVIT';
  showFooterLegal?: boolean;
}): JSX.Element => {
  return (
    <div id="hc-pet-insurance__footer" data-testid="hc-pet-insurance__footer">
      <div className="hc-pet-insurance__footer--cta">
        <KibButtonNew
          {...primaryCTA}
          size="large"
          onClick={primaryCTA.onClick}
          disabled={primaryCTA.disabled != undefined && primaryCTA.disabled}
        >
          {primaryCTA.label}
        </KibButtonNew>
        {secondaryCTA && (
          <KibButtonNew
            {...secondaryCTA}
            size="large"
            emphasis="secondary"
            onClick={secondaryCTA.onClick}
            disabled={
              secondaryCTA.disabled != undefined && secondaryCTA.disabled
            }
          >
            {secondaryCTA.label}
          </KibButtonNew>
        )}
      </div>

      {showFooterLegal && (
        <div className="hc-pet-insurance__footer--legal">
          <LegalText prefix={legalText} />
        </div>
      )}
    </div>
  );
};
